import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Customer } from "../../../../shared/types/customers";
import { getApp } from "../app";

@Component({
    selector: "app-users",
    templateUrl: "./users.component.html",
    styleUrls: ["./users.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersComponent implements OnInit {
  columns: string[] = [];
  columnList: string[] = [];
  app = getApp((app) => {
    this.app = app;
  });
  filterOpen = false;
  showCounter = false;
  selected = new Set<string>();

  selectedFilters: { columnName: string; value: string }[] = [];

  constructor() {}

  async ngOnInit() {
    this.app.type = "user";
    await this.app.users.getListOfUsers();
    if (
      this.app.auth.isTeam &&
      this.app.customers.expectCurrent !== Customer.DB
    ) {
      this.columns = this.app.list.user.readonlyView;
    } else {
      this.columns = this.app.list.user.columns;
    }
    this.columnList = this.columns.map((col) => col.split(".")[1]);
  }

  isSelected(id: string) {
    return this.selected.has(id);
  }

  async checkPermission(userName: string, id: string) {
    this.selected.clear();
    this.selected.add(userName);
    this.app.field.getFieldSettings("user.email").mutable = false;
    this.app.field.getFieldSettings("user.name").mutable = false;
    if (
      this.app.auth.isTeam &&
      this.app.customers.expectCurrent === Customer.NS
    ) {
      return;
    } else {
      await this.app.users.getUserByIdAsync(id);
      // this.app.users.getUserById(userName);
      this.app.users.creationOpen = true;
      this.app.users.isNew = false;
      this.app.state.viewUser = userName;
      this.app.users.currentUserName = userName;
      this.app.unlockedId = null;
      this.app.userSettings.initSettings();
    }
  }
}
